import {TepeeInfo} from "../types/info";
import {FaUserGroup, FaTent, FaRulerCombined, FaBed, FaBasketShopping, FaChair} from "react-icons/fa6";
import { ReactNode } from "react";


interface TepeeButtonProps extends TepeeInfo {
    isSelected: boolean;
    onSelect: () => void;
}

interface TepeeButtonDetails {
    text: string;
    icon: ReactNode;
}

const detailsBasic: TepeeButtonDetails[] = [
    {text:"Hasta 3 personas", icon:FaUserGroup({})},
    {text:"Bell tent de nylon", icon:FaTent({})},
    {text:"10.7 m\u00B2 de área", icon:FaRulerCombined({})},
    {text:"3 colchonetas individuales memory foam", icon:FaBed({})}
]

const detailsRegular: TepeeButtonDetails[] = [
    {text:"Hasta 2 personas", icon:FaUserGroup({})},
    {text:"Bell tent lona de algodón natural", icon:FaTent({})},
    {text:"12.6 m\u00B2 de área", icon:FaRulerCombined({})},
    {text:"Cama matrimonial o individuales inflables", icon:FaBed({})},
    {text:"Sábanas", icon:FaBasketShopping({})}
]

const detailsPremium: TepeeButtonDetails[] = [
    {text:"Hasta 2 personas", icon:FaUserGroup({})},
    {text:"Bell tent lona de algodón natural", icon:FaTent({})},
    {text:"12.6 m\u00B2 de área", icon:FaRulerCombined({})},
    {text:"Cama matrimonial o individuales inflables (elevados con memory foam)", icon:FaBed({})},
    {text:"Sábanas, edredón y frazada", icon:FaBasketShopping({})},
    {text:"Dos sillas y una mesa lateral", icon:FaChair({})}
]

const TepeeButton = (tepee: TepeeButtonProps) => {
    const title = tepee.name;
    let imageUrl;
    let details: TepeeButtonDetails[] = [];
    switch (tepee.name){
        case "Básica":
            imageUrl = "images/T-Basica.png"
            details = detailsBasic
            break;
        case "Regular":
            imageUrl = "images/T-Regular.png"
            details = detailsRegular
            break;
        case "Premium":
            imageUrl = "images/T-Premium.png"
            details = detailsPremium
            break;
    }

    const selectionClasses = tepee.isSelected
        ? 'bg-[#4c6a4d] text-white'
        : 'bg-[#fff8e7] hover:-translate-y-4';

    return (
        <div className={`relative grid text-center p-4 rounded-2xl shadow-xl cursor-pointer transition-all ${selectionClasses}`} onClick={tepee.onSelect}>
            <p className="text-3xl font-thin">{title}</p>
            <div className="text-left text-sm mt-4 md:min-h-[25svh]">
                {details.map((detail, index) =>
                    <div key={index} className="flex gap-2">
                        <div className="mt-1">{detail.icon}</div>
                        <div>{detail.text}</div>
                    </div>
                )}
            </div>
            {/*<p className="mt-4 lea">{body2}</p>*/}
            {/*<p>{body3}</p>*/}
            <p className="font-bold text-3xl mt-4">{tepee.price}</p>
            <p className="md:mb-[360px] mb-[70svh] font-bold">por persona por noche</p>
            <img src={imageUrl} alt={title} className="absolute bottom-0 rounded-b-2xl h-[70svh] md:h-[360px] w-full"/>
        </div>
    )
}

export default TepeeButton;